import { Timestamp } from "firebase/firestore";
import { Translations } from "shared/types/languages";

export type Bulletin = {
  id: string;
  title: string;
  description: string;
  adminNotes: string;
  isHighPriority: boolean;
  status: BulletinStatus;
  publishedAt: Timestamp | null;
  translations?: Translations;
};

export enum BulletinDetailsTabs {
  General,
  Translations,
}

export enum BulletinStatus {
  Active = "active",
  Draft = "draft",
}

export type UpdateStatusParams = {
  bulletinId: string;
  status: BulletinStatus;
};

export type BulletinDataToCreate = Omit<
  Bulletin,
  "id" | "updatedAt" | "publishedAt"
>;

export type BulletinDataToUpdate = Partial<Omit<
  Bulletin,
  "id" | "updatedAt"
>>;
